import React from 'react';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText, IconButton } from '@mui/material/';
import LocalFilerRecord from '../dataObjects/LocalFilerRecord';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateField } from '@mui/x-date-pickers/DateField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { DateValidationError, PickerChangeHandlerContext } from '@mui/x-date-pickers';

interface Props {
    currentRecord: LocalFilerRecord | null;
    isEditing: boolean;
    openDialog: boolean;

    handleCloseDialog: () => void;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleDateChange: (fieldName: string) => (value: Dayjs | null, context: PickerChangeHandlerContext<DateValidationError>)  => void;
    handleSave: () => Promise<void>;

    errors: {
        town: { error: boolean, helperText: string }
    }
}

const EditOrAddNewFilerRecord = (props: Props) => {


    return (
        <div>
            <Dialog open={props.openDialog} onClose={props.handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>{props.isEditing ? 'Edit Filer Record' : 'Add New Filer Record'}</DialogTitle>
                <DialogContent>
                    <TextField name="town" label="Town" value={props.currentRecord?.town || ''} onChange={props.handleInputChange} fullWidth margin="normal" error={props.errors.town.error} helperText={props.errors.town.helperText} />
                    <TextField name="candidateName" label="Candidate Name" value={props.currentRecord?.candidateName || ''} onChange={props.handleInputChange} fullWidth margin="normal" />
                    <TextField name="candidateAddress" label="Candidate Address" value={props.currentRecord?.candidateAddress || ''} onChange={props.handleInputChange} fullWidth margin="normal" />
                    <TextField name="candidateCsz" label="Candidate City/State/Zip" value={props.currentRecord?.candidateCsz || ''} onChange={props.handleInputChange} fullWidth margin="normal" />
                    <TextField name="candidateSalutation" label="Candidate Salutation" value={props.currentRecord?.candidateSalutation || ''} onChange={props.handleInputChange} fullWidth margin="normal" />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker slotProps={{
                            textField: { name: 'notifiedByClerk' }
                        }} sx={{ width: '100%', mt: 2, mb: 2 }} label="Notified by City/Town Clerk" value={props.currentRecord?.notifiedByClerk ? dayjs(props.currentRecord.notifiedByClerk) : null} onChange={props.handleDateChange('notifiedByClerk')} ></DatePicker>
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker slotProps={{
                            textField: { name: 'letterSent' }
                        }} sx={{ width: '100%', mt: 2, mb: 2 }} label="CPF Letter Sent" value={props.currentRecord?.letterSent ? dayjs(props.currentRecord.letterSent) : null} onChange={props.handleDateChange('letterSent')}></DatePicker>
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker slotProps={{
                            textField: { name: 'filedDate' }
                        }} sx={{ width: '100%', mt: 2, mb: 2 }} label="Report Filed" value={props.currentRecord?.filedDate ? dayjs(props.currentRecord.filedDate) : null} onChange={props.handleDateChange('filedDate')}></DatePicker>
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker slotProps={{
                            textField: { name: 'closedDate' }
                        }} sx={{ width: '100%', mt: 2, mb: 2 }} label="Matter Closed" value={props.currentRecord?.closedDate ? dayjs(props.currentRecord.closedDate) : null} onChange={props.handleDateChange('closedDate')}></DatePicker>
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker slotProps={{
                            textField: { name: 'referralDate' }
                        }} sx={{ width: '100%', mt: 2, mb: 2 }} label="Referral Date" value={props.currentRecord?.referralDate ? dayjs(props.currentRecord.referralDate) : null} onChange={props.handleDateChange('referralDate')}></DatePicker>
                    </LocalizationProvider>
                    <TextField name="notes" label="Notes" value={props.currentRecord?.notes || ''} onChange={props.handleInputChange} fullWidth margin="normal" multiline rows={4} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleCloseDialog}>Cancel</Button>
                    <Button onClick={props.handleSave} color="primary">Save</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default EditOrAddNewFilerRecord;